import { render, staticRenderFns } from "./signup-link.vue?vue&type=template&id=644a91ea&scoped=true&"
import script from "./signup-link.vue?vue&type=script&lang=js&"
export * from "./signup-link.vue?vue&type=script&lang=js&"
import style0 from "./signup-link.vue?vue&type=style&index=0&id=644a91ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a91ea",
  null
  
)

export default component.exports